export default "__VITE_ASSET__Byxh5TI1__";